import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";
import { EDocumentProductDataType } from "@/formTypes/EDocumentProductDataType";

export type InvoiceTemplateProductDataType = Partial<ApiSchema["InvoiceTemplateProduct"]["type"] & EDocumentProductDataType>;
export const InvoiceTemplateProductApi = new GenericModelApi<"InvoiceTemplateProduct", InvoiceTemplateProductDataType>("InvoiceTemplateProduct", "codigo");